import React from 'react';
import TpEvaluatorService from '../../../Services/TpEvaluatorService';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import TpEvaluatorEmailCampaignSearchParams from './TpEvaluatorEmailCampaignSearchParams';
import TpEvaluatorEmailCampaignItem from '../../../Domain/TpEvaluatorEmailCampaignItem';
import ErrorMessage from '../../../Elements/ErrorMessage';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';

class TpEvaluatorEmailCampaignAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new TpEvaluatorEmailCampaignSearchParams(),
      cleared: process.env.NODE_ENV !== 'development',
    };
    this.startSearch = this.startSearch.bind(this);
    this.startExport = this.startExport.bind(this);
    this.handleExportOnClick = this.handleExportOnClick.bind(this);
  }

  startSearch(searchItem) {
    this.setState({
      searchItem,
      cleared: false,
    });
  }

  startExport() {
    TpEvaluatorService.ExportToExcelForView(this.state.searchItem).catch(() =>
      ErrorMessage.SetErrorMessage('TPEECA33')
    );
    ErrorMessage.SetSuccessWithWait(
      'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
    );
  }

  handleExportOnClick() {
    if (this.state.searchItem.IncludeSelfDeactivated === 'true') {
      ErrorMessage.SetApprove(
        <span>
          The search included self-deactivated shoppers.
          <br />
          Are you sure you want to proceed with the export?
        </span>,
        () => this.startExport()
      );
    } else {
      this.startExport();
    }
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={TpEvaluatorEmailCampaignItem}
          serviceFunction={TpEvaluatorService.GetAllItemBySearchingForEmailCampaign}
          convertDBItemsFunction={TpEvaluatorService.ConvertDBItemsForEmailCampaign}
          searchParamsType={TpEvaluatorEmailCampaignSearchParams}
          orderDirection={OrderDirectionsEnum.Asc}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          cleared={this.state.cleared}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in different id, name or email...'
          errorCode='TPEECA70'
          isExportExcelDisabled={false}
          clickOnExportExcel={this.handleExportOnClick}
        />
      </div>
    );
  }
}

export default TpEvaluatorEmailCampaignAdmin;
